import React from "react";
import MyTimesheets from "./MyTimesheets";

export default function TimesheetsIndex() {
    return <MyTimesheets />;
}